<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-flex xs12>
                <v-card>
                     <v-card-text>
                         <v-container fluid>
                              <v-layout row wrap>
                                  <v-col cols="12">
                                      <h2>Edit Status</h2>
                                      <p>Note: If you are looking to void a corrupted reservation record please use the void feature instead</p>
                                      <p>Note: This will only update the status; it will not recalculate the prices, nor dispatch channel manager notifications, nor send emails to hoteliers or clients</p>
                                  </v-col>

                                  <v-col cols="12" md="3">
                                      <label>Status:</label>
                                  </v-col>

                                  <v-col cols="12" md="9">
                                      <v-select
                                          v-model="reservation.status_key"
                                          :items="statusOptions"
                                          autocomplete
                                      ></v-select>
                                  </v-col>

                                  <v-col cols="12" md="3">
                                      <label>Reason For Change:</label>
                                  </v-col>

                                  <v-col cols="12" md="9">
                                      <v-text-field
                                         name="reason" 
                                         v-model="reason"
                                      ></v-text-field>
                                  </v-col>
                              </v-layout>
                          </v-container>
                      </v-card-text>

                      <v-card-actions>
                          <v-btn class="" 
                              v-on:click="cancel"
                              title="Cancel without changes">Cancel</v-btn>
                          <v-btn class="ies-green" 
                              title="Save the changes to the reservation"
                              v-on:click="saveChanges">Save</v-btn>
                      </v-card-actions>
                 </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    /**
     * A Vue component dedicated to letting the user update the status of a reservation
     *
     * Props:
     *     int 'reservationkey' - The ID of the reservation to display
     */
    import axios from 'axios';
    // Import the application event bus so we can listen for data changes and react accordingly
    import EventBus from '@/eventBus';
    export default {

        name: 'hotel-reservation-change-status',
        props: ['reservationkey'],
        data () {
            return {
                reservation: {},
                statusOptions: [
                                  {value: 8, text: "New Enquiry"},
                                  {value: 10, text: "Re-Enquiry"},
                                  {value: 11, text: "Availability Confirmed by Property"},
                                  {value: 16, text: "No Availability"},
                                  {value: 20, text: "Alternative Offered by Property"},
                                  {value: 14, text: "Quote Expired"},
                                  {value: 15, text: "Quote Declined by Client"},
                                  {value: 19, text: "Quote Declined - Confirmed by Property"},
                                  {value: 13, text: "Quote Accepted by Client"},
                                  {value: 12, text: "Reservation Confirmed by Property"},
                                  {value: 17, text: "Reservation Cancelled"},
                                  {value: 18, text: "Reservation Cancelled - Confirmed by Property"},
                                  {value: 9, text: "Completed"},
                ],
                reason: ""
            }
        },
        methods: {

            /**
             * Register event listener that will be listening for clearSelector event to clear it's selected state
             */
            setUpEventListeners() {
                EventBus.$on('Reservation Administration: Reservation changed', this.onReservationChanged);
            },

            /**
             * @method onReservationChanged
             * 
             * Respond to the reservation having been edited
             * by checking if the event is talking about this reservation,
             * and if so then reload it afresh so we are displaying all of
             * the correct data across the board
             * 
             * @param payload 
             */
            onReservationChanged(payload){
                if (payload.reservationKey == this.reservationkey){
                   this.loadReservation();
                }
            },

            loadReservation(){
                axios.get('/api/reservations/id/' + this.reservationkey)
                .then(function(response){
                    this.reservation = response.data.reservation;
                }.bind(this));
            },

            /**
             * Push the changes up to the server
             */
            saveChanges(){
                var params = {
                    statusKey: this.reservation.status_key,
                    reason: this.reason
                };
                axios.post('/api/reservation/' + this.reservationkey + '/set-status', params)
                .then(function(response){
                    alert("Status updated - you may need to refresh your listing to see it appear in the correct section");
                    EventBus.$emit('Reservation Administration: Reservation changed', {'reservationKey': this.reservationkey});
                    EventBus.$emit('Reservation Administration: Task change', {'reservationKey': this.reservationkey, 'taskName': 'manage reservation'});
                }.bind(this));
            },

            cancel(){
                EventBus.$emit('Reservation Administration: Task change', {'reservationKey': this.reservationkey, 'taskName': 'manage reservation'});
            },
        },
        
        /**
         * Once mounted this component needs to load the reservation specified
         */
        mounted() {
            this.loadReservation();
            this.setUpEventListeners();
        },

        computed: {}
    }
</script>
